//Clase de la aplicacion BextDocUI
//Autor:Marlon Granda-Fecha:25/21/2019 - Mail:mar_gran2003@yahoo.com.ar
//Empresa:Marlon Granda

import { Component, ViewChild, OnInit, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Paginas, ControllerMethods, DataTableAjaxOrderTypes, TypesUseForm, ControlActions, EntityMetadataTypes, TipoParaPermisos } from '../../../models/general.enum';
import { Utilities } from '../../../helpers/utilities';
import { ModalNotifyComponent, ModalNotifyTypes } from '../../../components/modal-notify/modal-notify.component';
import { BaseServiceService } from '../../../services/base-service.service'
import { BaseCrud } from '../../../bussines/base-crud';
import { GeneralFormComponent } from '../../controls/general-form/general-form.component';
import { HelperImages } from 'src/app/helpers/helper-images';
import { HelperRules } from 'src/app/helpers/helper-rules';
import { HelperActions } from 'src/app/helpers/helper-actions';
import { StaticData } from 'src/app/helpers/static-data';
import { Enumerable, List } from "../../../../assets/linqts/compilado/index";

@Component({
  selector: 'app-rtipo-solicitud',
  templateUrl: './rtipo-solicitud.component.html',
  styleUrls: ['./rtipo-solicitud.component.scss']
})
export class RTipoSolicitudComponent extends GeneralFormComponent implements OnInit, AfterViewInit {

  onEditParentEmitter: EventEmitter<any> = new EventEmitter<any>();

  crearPaginas = false;
  nombreLleno = false;
  camposColor = ['ColorMaxima', 'Color1', 'Color2', 'Color3'];

  tiposSolicitudes: Array<any> = [1
    , 2
    , 3
    , 4
    , 5
    , 6
    , 7
    , 8
    , 9
    , 10
    , 13
    , 14
    , 15
    , 16
    , 21
    , 22];


  get VerAdminForm(): any {

    let tipo = null;
    if (this.modelo && this.modelo.modelo) {
      tipo = this.tiposSolicitudes.find((x => { return x == this.modelo.modelo.IdTipoSolicitud; }));
    }
    return (this.crearPaginas && !tipo);
  }

  constructor(public baseService: BaseServiceService, public utility: Utilities,
    public helperImages: HelperImages,
    public helperRules: HelperRules,
    public helperActions: HelperActions) {

    super(baseService, utility, helperImages, helperRules, helperActions);
  }

  // ngAfterViewInit() {
  //
  // 	this.userModel.Nueva();
  // }

  public OnInitEnd() {


    // this.postClearEmitter.subscribe(data => {
    //   this.nombreLleno = false;
    // });




    // this.postSaveEmitter.subscribe(data => {
    //
    // 	let obj = this.utility.GetApiModel("ConsultaRolesGruposUsuariosAreasEmpresaTipo", null);
    //   obj.QueryConfig = {
    //     Command: "ConsultaRolesGruposUsuariosAreasEmpresaTipo",
    //     IsSp: true,
    //     Entity: {
    //       IdEmpresa: 1
    //     },
    //   };
    //   let info = {
    //     componentName: this.componentName,
    //     controlName: "ConsultaRolesGruposUsuariosAreasEmpresaTipo",
    //     processMessage: "Cargando ConsultaIndicativo......",
    //   };

    //   this.baseService
    //     .Get(obj, null, info, this.componentName, false, false)
    //     .then((data) => {
    //
    // StaticData.RolesUsuariosGrupos = new List<any>(data.Data);
    //     })
    //     .catch((err) => {
    //       this.utility.logger.LogError(err, obj, {
    //         componentName: this.componentName,
    //         method: "Consulta",
    //       });
    //     });

    // });


  }

  private ValidarColorDuplicado(idDatoBasico: number, campoActual: string): boolean {
    try {
        let contador = 0;
        
        for (const key in this.modelo.modelo) {
            if (key.includes("Color") && 
                key !== campoActual && // se excluye el campo actual
                this.modelo.modelo[key] === idDatoBasico) {
                contador++;
                
                if (contador >= 1) {
                    return true;
                }
            }
        }
        
        return false;
    } catch (error) {
        this.utility.logger.LogError(error, null, {
            componentName: this.componentName,
            method: "validarColorDuplicado",
        });
        return false;
    }
  }

  private ActualizarImagenColor(controlName: string, nombreColor: string) {
    setTimeout(() => {
      const imgElement = document.getElementById(`Img${controlName}`) as HTMLImageElement;

      if (imgElement) {
        const contenedorOculto = imgElement.closest('.ms-Grid-col.ms-sm12.ms-md12.ms-lg12.sortable-field');
          
          if (contenedorOculto && contenedorOculto instanceof HTMLElement) {
              
            if (contenedorOculto.hasAttribute('hidden')) {
                contenedorOculto.removeAttribute('hidden');
            }
            
            const computedStyle = window.getComputedStyle(contenedorOculto);
            if (computedStyle.display === 'none') {
                contenedorOculto.style.display = 'block';
            }
            
            void contenedorOculto.offsetHeight;
          }     
        
        const colorMap: { [key: string]: string } = {
          'rojo': 'red',
          'verde': 'green', 
          'azul': 'blue',
          'amarillo': 'yellow'
        }

        const colorNormalizado = nombreColor.toLowerCase().trim();
        let nombreArchivo = '';

        for (const [color, archivo] of Object.entries(colorMap)) {
          if (colorNormalizado.includes(color) || color.includes(colorNormalizado)) {
            nombreArchivo = archivo;
            break;
          }
        }
        const nuevaUrl = `../assets/images/jstree/icos/${nombreArchivo}.svg`;
        imgElement.src = nuevaUrl;
        
      } else {
        setTimeout(() => this.ActualizarImagenColor(controlName, nombreColor), 100);
      }

    }, 50);
}

  public OnDataTableEditHandler(event) {

    super.OnDataTableEditHandler(event);
    this.nombreLleno = true;
    this.onEditParentEmitter.emit(event);
  }
  public OnUpdateHandler(value, configuracion) {
    //debugger;
    //this.form.controls['Configuracion'].setValue(value.Configuracion);
    this.form.controls['ConfiguracionPaginaSolicitud'].setValue(value.ConfiguracionPaginaSolicitud);
    this.form.controls['ConfiguracionPaginaEstadoSolicitud'].setValue(value.ConfiguracionPaginaEstadoSolicitud);
  }

  public OnSelectedComboBox(item: any, controlName: string, config: any) {
    try {

      if (item){
        if (controlName.includes("Color")) {
          if (!this.modelo.modelo[`${controlName}`]) {
            this.modelo.modelo[`${controlName}`] = null;
          }

          if (item && this.ValidarColorDuplicado(item.IdDatoBasico, controlName)) {

            var conf = `Config${controlName}`
            var itemsCombo = this.configs[`${conf}`].Context.items;

            this.configs[`${conf}`].Context.ResetComboBox(itemsCombo, true);
            this.modelo.modelo[`${controlName}`] = null;

            this.utility.VerModalWarning({
                    titulo: 'Alerta', descripcion: `El color ${item.Nombre} ya se utiliza en otra alerta. Por favor seleccione uno diferente`,
                    verOk: true, verCancelar: false, ok: 'Aceptar', cancelar: 'NO'
                  }).then(data => { });
          }else{
            this.ActualizarImagenColor(controlName, item.Nombre);
          }
        }
      } else {
        this.OcultarImagenColor(controlName);
        var conf = `Config${controlName}`;
        var itemsCombo = this.configs[`${conf}`].Context.items;
        this.configs[`${conf}`].Context.ResetComboBox(itemsCombo, true);
        this.modelo.modelo[`${controlName}`] = null;
      }

    } catch (error) {
      this.utility.logger.LogError(error, null, {
        componentName: this.componentName,
        method: "OnSelectedComboBox",
        controlName: controlName,
      });
      this.utility.VerModalDanger().then((data) => { });
    }
  }

  private OcultarImagenColor(controlName: string) {
    setTimeout(() => {
      const imgElement = document.getElementById(`Img${controlName}`) as HTMLImageElement;
      
      if (imgElement) {
        const contenedorOculto = imgElement.closest('.ms-Grid-col.ms-sm12.ms-md12.ms-lg12.sortable-field');
        
        if (contenedorOculto && contenedorOculto instanceof HTMLElement) {
            contenedorOculto.setAttribute('hidden', 'true');
            contenedorOculto.style.display = 'none';
        }
      }
    }, 50);
  }

  _Guardar(form: FormGroup, configuracion) {
    //debugger;
    this.modelo.modelo.UsuariosPermitidos = ''
    const ids: number[] = [];
    let PermisosUsuarios =  new List<any>([]);
    if(this.modelo.modelo.Configuracion != null || this.modelo.modelo.Configuracion !="[]"){
      try {
        const jsonArray = JSON.parse(this.modelo.modelo.Configuracion);

        if (Array.isArray(jsonArray)) {
          for (const jsonObject of jsonArray) {
            if (jsonObject && jsonObject.Id !== undefined) {
              const id = jsonObject.Id;
              if (typeof id === 'number') {
                PermisosUsuarios.Add('code' + id)
              }
            }
          }
          this.modelo.modelo.UsuariosPermitidos = PermisosUsuarios.ToArray().join('|');

        }
      } catch (error) {
        console.error('Error parsing JSON:', error);
      }

    }
    super._Guardar(form, configuracion)
    this.camposColor.forEach(color => {
      this.OcultarImagenColor(color);
    })

  }

  public OnActionEventHandler(event) {

    super.OnActionEventHandler(event);
    if (event.Option.Label === "Editar"){
      setTimeout(() => {
        this.ActivarTodosLosImgColor();
      }, 800);
    }
  }

  private ActivarTodosLosImgColor() {
    
    
    this.camposColor.forEach(campo => {
      const valorColorId = this.modelo.modelo[campo];
      if (valorColorId) {
        this.CargarYMostrarColor(campo, valorColorId);
      }
    });
  }

  private CargarYMostrarColor(campo: string, idDatoBasico: number, intentosMaximos: number = 10, 
    delayInicial: number = 300) {

    let intentos = 0;
    
    const intentarCarga = () => {
      intentos++;
      const configKey = `Config${campo}`;
      
      if (this.configs[configKey] && this.configs[configKey].Context && 
        this.configs[configKey].Context.items && this.configs[configKey].Context.items.length > 0) {
            
        const items = this.configs[configKey].Context.items;
        const itemColor = items.find((item: any) => item.IdDatoBasico === idDatoBasico);
        
        if (itemColor) {          
          this.ActualizarImagenColor(campo, itemColor.Nombre || itemColor.Palabra);
        }
      } else if (intentos < intentosMaximos) {
        const nextDelay = delayInicial * Math.pow(1.5, intentos - 1);
        setTimeout(intentarCarga, nextDelay);
      }
    }
    setTimeout(intentarCarga, delayInicial);
  }

  public Limpiar(callback: (data: any) => void = null, action?: any){
    this.camposColor.forEach(color => {
      this.OcultarImagenColor(color);
    })
    super.Limpiar()
  }
}


